import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FeedTrackingService } from '@app/+feed/service/feed-tracking.service';
import { FeedCard } from '@vestiaire/api-sdk-angular';
import { ISeeMemberEvent } from '../feed-card-profile/feed-card-profile.component';
import { ISeeProduct } from '../feed-card-new-ins/feed-card-new-ins.component';
import { ILikeProduct } from '../feed-card-new-ins/feed-card-new-ins.component';
import { IHideRecommended } from '../feed-suggestions/feed-suggestions.component';

@Component({
  selector: 'vc-feed-card',
  templateUrl: './feed-card.component.html',
  styleUrls: ['./feed-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedCardComponent {
  @Input() card: FeedCard;
  @Input() newFollow = false;
  @Input() likedItems: string[];

  constructor(private feedTrackingService: FeedTrackingService) {}

  followMember(memberId: string) {
    this.feedTrackingService.trackFollowButtonClick(this.card, this.card.actor.trackingKey);
    if (memberId === this.card.actor.describes.id) {
      this.card.actor.isFollowed = true;
      this.newFollow = true;
    }
  }

  trackRecommended($event: ISeeMemberEvent) {
    this.feedTrackingService.trackRecommendedFollowButtonClick(this.card, $event.profileId, $event.trackingKey);
  }

  trackHideRecommended($event: IHideRecommended) {
    this.feedTrackingService.trackRecommendedHideClick(this.card, $event);
  }

  trackSeeProfile($event: ISeeMemberEvent) {
    this.feedTrackingService.trackSeeProfile(this.card, $event.emitter, $event.profileId, $event.trackingKey);
  }

  trackSeeProduct(event: ISeeProduct) {
    this.feedTrackingService.trackProductClick(this.card, event.product.productId, event.position);
  }

  trackSeeMoreProduct(event: string) {
    this.feedTrackingService.trackSeeMoreProductClick(this.card, event);
  }

  trackLikeProduct(event: ILikeProduct) {
    this.feedTrackingService.trackLikeClick(this.card, event.product.productId, event.position, event.isLiked);
  }
}
